import React from 'react';
import PropTypes from 'prop-types';
import ReactCountdown from 'react-countdown';
import { CountdownRenderer } from './CountdownRenderer';

export const UHCCountdown = ({ countdownMS, renderer, ...props }) => {
  return (
    <ReactCountdown
      {...props}
      date={Date.now() + countdownMS}
      renderer={renderer}
    />
  );
};

UHCCountdown.propTypes = {
  countdownMS: PropTypes.number,
  renderer: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
};

UHCCountdown.defaultProps = {
  countdownMS: 600000,
  renderer: CountdownRenderer,
};
